export default __webpack_public_path__ + "static/media/Golden-Snitch-3D-Model-00.f2a99b3f.jpg";